module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'ztssv44p',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
